import React, { useMemo, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { useUiLanguageStore } from '../store/uiLanguageStore';
import { jylawTheme } from './index';

const ltrCache = createCache({ key: 'mui-ltr' });
const rtlCache = createCache({ key: 'mui-rtl', stylisPlugins: [prefixer, rtlPlugin] });

export const RTLProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { direction } = useUiLanguageStore();

  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = useUiLanguageStore.getState().locale;
  }, [direction]);

  const theme = useMemo(
    () => createTheme({ ...jylawTheme, direction }),
    [direction],
  );

  const cache = direction === 'rtl' ? rtlCache : ltrCache;

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
};
